export function stripDocumentMask(value: string): string {
  return value?.replace(/[.-]/g, '') || '';
}

export const DOCUMENT_TYPES = [
  { label: 'DNI', value: 'dni' },
  { label: 'CUIT', value: 'cuit' },
  { label: 'CUIL', value: 'cuil' },
];

export const DNI_MASK = '00.000.000';
export const CUIT_CUIL_MASK = '00-00000000-0';

export function getDocumentMask(documentType: string): string {
  return documentType === 'dni' ? DNI_MASK : CUIT_CUIL_MASK;
}
